let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ikw1V")).then(() => parcelRequire('9aLf6'));